import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 30px 36px 36px 36px;
`

export const s = {
  Wrapper
}
